import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { MarcaModelo } from '@tivic-team/manager-ts/dist/fta/entities/marca-modelo.entity';
import { MarcaModeloSearch } from 'app/services/fta/marca-modelo.search';
import { MarcaModeloService } from 'app/services/fta/marca-modelo.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ParentFormGroup } from 'utils/parent-formgroup';

@Component({
    selector: 'auto-complete-marca-modelo',
    templateUrl: './auto-complete-marca-modelo.component.html',
    styleUrls: ['./auto-complete-marca-modelo.component.scss'],
    viewProviders: [ParentFormGroup],
})
export class AutoCompleteMarcaModeloComponent implements OnInit, AfterViewInit {
    formGroup: FormGroup;
    @Input() controlName: string;
    marcaModelos: MarcaModelo[];
    marcaModelosFiltrados: MarcaModelo[];

    @ViewChild('cdMarcaVeiculo', { static: false }) cdMarcaVeiculo: ElementRef;

    constructor(private _marcaModeloService: MarcaModeloService, private _controlContainer: ControlContainer) {}

    async ngOnInit() {
        this.formGroup = this._controlContainer.control as FormGroup
        this.formGroup.addControl('marcaModelo', new FormControl());
        this.formGroup
            .get('marcaModelo')
            .valueChanges.pipe(
                switchMap((value) => {
                    if (value && typeof value === 'string' && value.length >= 2) {
                        return this._marcaModeloService.find(new MarcaModeloSearch({ keyword: value }));
                    } else {
                        return of(null);
                    }
                })
            )
            .subscribe((marcaModelos) => (this.marcaModelosFiltrados = marcaModelos));
    }

    async ngAfterViewInit() {
        if(this.formGroup.value.cdMarca) {
            this.selecionarMarcaModelo(this.formGroup.value.cdMarca)
            this.getById(this.formGroup.value.cdMarca)
        }
        
        this.formGroup
            .get(this.controlName)
            .valueChanges.pipe(
                switchMap(async (cdMarcaVeiculo) => {
                    console.log(`Autocomplete MarcaModelo: ${cdMarcaVeiculo}`);
                    this.getById(cdMarcaVeiculo);
                    return of(null);
                })
            )
            .subscribe();
    }

    displayFn(marcaModelo: MarcaModelo) {
        if (marcaModelo) {
            return marcaModelo.nmModelo;
        }
    }

    async getById(cdMarcaVeiculo: number) {
        if (cdMarcaVeiculo > 0) {
            let marcaModelo: MarcaModelo = await this._marcaModeloService.get(cdMarcaVeiculo);

            if (marcaModelo == null)
                console.log('Marca/Modelo de veículo indicado não existe no banco ou houve um erro ao busca-la.');
            else {
                this.formGroup.get('marcaModelo').setValue(marcaModelo);
                this.cdMarcaVeiculo.nativeElement.value = marcaModelo.nmModelo;
            }
        }
    }

    async marcaModeloSelecionado($event) {
        let marcaModelo = $event.option.value;
        this.selecionarMarcaModelo(marcaModelo.cdMarca || marcaModelo.codMarca);
    }

    selecionarMarcaModelo(cdMarcaVeiculo: number) {
        this.formGroup.get(this.controlName).setValue(cdMarcaVeiculo);
    }

    reset() {
        this.cdMarcaVeiculo.nativeElement.value = '';
        this.formGroup.get('cdMarca').reset();
    }
}
